module.exports = __webpack_public_path__ + "static/media/purinspect.a471dd96.svg";